import { gql } from '@apollo/client';

export const CreatePerson = gql`
  mutation CreatePerson($email: String!, $data: PersonInput!) {
    createPerson(email: $email, data: $data)
  }
`;
